import { render, staticRenderFns } from "./sms-table.vue?vue&type=template&id=ba9ae1fc&scoped=true&"
import script from "./sms-table.vue?vue&type=script&lang=js&"
export * from "./sms-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ae1fc",
  null
  
)

export default component.exports